var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "liquidity-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [_c("ImportPool", { on: { select: _vm.reloadList } })]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("WindowModal", {
        attrs: { title: _vm.modalRemoveTitle, type: "Remove" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("RemoveLiquidity", {
                  ref: "removeLiquidity",
                  attrs: { pool: _vm.pickedPool, transaction: _vm.transaction },
                  on: {
                    removeLiquidity: _vm.removeLiquidity,
                    initSettingsState: function ($event) {
                      return _vm.changeModalTitle("settings")
                    },
                    initConfirmState: function ($event) {
                      return _vm.changeModalTitle("init")
                    },
                    initLoading: function ($event) {
                      return _vm.changeModalTitle("loading")
                    },
                    initSuccess: function ($event) {
                      return _vm.changeModalTitle("success")
                    },
                    initError: function ($event) {
                      return _vm.changeModalTitle("error")
                    },
                    closeRemoveModal: _vm.closeModal,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "liquidity-box" },
        [
          _c("div", { staticClass: "image-area" }, [
            _c("div", { staticClass: "picture" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/floatie-token.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "490",
                      sizes: "sm:250px md:300px lg:350px xl:400px xxl:440px",
                      src: "/img/new/floatie-token.png",
                      alt: "Provide $FLOATIE liquidity pairs",
                      title: "$FLOATIE tokens stats, liquidity, price",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("h1", [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("pool.liquidity_header")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("pool.liquidity_subheader")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "nuxt-link",
            {
              staticClass: "independent-link",
              attrs: { to: _vm.localePath("/docs") },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("pool.read_more")) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "divider-horizontal" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttons-area" },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "btn cyan",
                  attrs: { to: _vm.localePath("/liquidity/add") },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pool.add_liquidity")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.user === undefined || _vm.user === null,
                      expression: "user === undefined || user === null",
                    },
                  ],
                  staticClass: "btn pink",
                  attrs: { type: "button" },
                  on: { click: _vm.openModalWallets },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.connect_wallet")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.user !== undefined && _vm.user !== null,
                      expression: "user !== undefined && user !== null",
                    },
                  ],
                  staticClass: "btn btn-outline pink",
                  attrs: { type: "button" },
                  on: { click: _vm.openImportModal },
                },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pools.import_pool")) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "active-pools" }, [
            (_vm.pairsListLoading || _vm.pairsList.length > 0) &&
            _vm.user !== undefined &&
            _vm.user !== null
              ? _c("div", { staticClass: "divider-horizontal" })
              : _vm._e(),
            _vm._v(" "),
            !_vm.pairsListLoading && _vm.pairsList.length > 0
              ? _c(
                  "section",
                  { staticClass: "pools-list" },
                  [
                    _c("div", { staticClass: "pools-header" }, [
                      _c("div", { staticClass: "h4" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("pools.your_liquidity")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "hint-icon wide-tooltip",
                          attrs: {
                            tooltip: _vm.$t("pools.your_liquidity_hint"),
                          },
                        },
                        [_c("Question")],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.pairsList, function (pool, index) {
                      return _c("div", { key: index, staticClass: "pool" }, [
                        _c("div", { staticClass: "tokens" }, [
                          _c(
                            "div",
                            { staticClass: "logos" },
                            [
                              _c("nuxt-img", {
                                attrs: {
                                  src:
                                    pool.token0.address !== _vm.$config.ZERO
                                      ? _vm.$getImageByAddress(
                                          pool.token0.address
                                        )
                                      : _vm.$getImage(pool.token0.logoURI),
                                  alt:
                                    pool.token0.name +
                                    " " +
                                    _vm.$config.appName,
                                  title: pool.token0.name,
                                  placeholder: "",
                                  lazy: true,
                                },
                                on: {
                                  error: function ($event) {
                                    $event.target.src = require("~/static/img/default_token.svg")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("nuxt-img", {
                                attrs: {
                                  src:
                                    pool.token1.address !== _vm.$config.ZERO
                                      ? _vm.$getImageByAddress(
                                          pool.token1.address
                                        )
                                      : _vm.$getImage(pool.token1.logoURI),
                                  alt:
                                    pool.token0.name +
                                    " " +
                                    _vm.$config.appName,
                                  title: pool.token0.name,
                                  placeholder: "",
                                  lazy: true,
                                },
                                on: {
                                  error: function ($event) {
                                    $event.target.src = require("~/static/img/default_token.svg")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  pool.token0.symbol +
                                    " / " +
                                    pool.token1.symbol
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "pool-hidden" }, [
                          _c("div", { staticClass: "pool-row" }, [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("pools.pooled") +
                                      " " +
                                      pool.token0.symbol +
                                      ":"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    pool.reserves !== undefined
                                      ? _vm.$formatCryptoAmount(
                                          pool.poolShare *
                                            pool.reserves.reserve0,
                                          6
                                        )
                                      : "..."
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pool-row" }, [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("pools.pooled") +
                                      " " +
                                      pool.token1.symbol +
                                      ":"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    pool.reserves !== undefined
                                      ? _vm.$formatCryptoAmount(
                                          pool.poolShare *
                                            pool.reserves.reserve1,
                                          6
                                        )
                                      : "..."
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pool-row" }, [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("pools.your_pooled_tokens") + ":"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$formatCryptoAmount(pool.balance, 6)
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pool-row" }, [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("pools.your_pooled_share") + ":"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$priceFormat(pool.poolShare * 100, 2) +
                                      "%"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("div", { staticClass: "pool-row" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn cyan",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addLiquidityRedirect(pool)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pools.add")) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn pink",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.prepareLiquidityRemovalApprove(
                                      pool,
                                      index
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pools.remove")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm.pairsListLoading &&
                _vm.user !== undefined &&
                _vm.user !== null
              ? _c("section", { staticClass: "loading-area" }, [
                  _c("div", { staticClass: "icon-area" }, [_c("Loading")], 1),
                  _vm._v(" "),
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pools.import_pool_loading")) +
                        "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud" },
        [_c("CloudCyanLiquidityLeft")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud2" },
        [_c("CloudCyanLiquidityRight")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }